import { realtimeSubscriptionAdapters } from '../adapters/subscription-adapters';
import type { PropsWithChildren } from 'react';
import { RealtimeContext } from './realtime-context';
import { useRealtimeClient } from '../hooks/use-realtime-client';

/**
 * Provides the authenticated application's shared realtime client.
 * @param props - Descendants that consume realtime state and events.
 * @returns The realtime context provider.
 */
export const RealtimeProvider = ({ children }: PropsWithChildren) => {
  const value = useRealtimeClient(realtimeSubscriptionAdapters);
  return (
    <RealtimeContext.Provider value={value}>
      {children}
    </RealtimeContext.Provider>
  );
};
